import { useEffect, useState } from "react";
import { Notification } from "./components/Notification";
import { useAuth } from "./contexts/AuthProvider/useAuth";
import { Login } from "./pages/Login";
import { Principal } from "./pages/Principal";

function App() {
  const auth = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (auth.usunome !== null)
      setLoading(false);
  }, [auth.usunome]);

  if (loading)
    return <div>Loading...</div>;

  return (
    <div>
      {!auth.token ? <Login /> : <Principal />}

      < Notification />
    </div>
  );
}

export default App;
